import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CARD_EMPTY_IMG, EMPTY_IMG_SQUARE } from '../../common/ui-constants';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgIf, NgStyle } from '@angular/common';


@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: true,
  imports: [NgStyle, NgIf, NgClass, MatIconModule, MatProgressSpinnerModule]
})
export class FileUploadComponent implements OnInit {

  editMode = false;

  @Input() src;
  @Input() imagePath: string;

  @Input()
  @HostBinding('style.height')
  height;

  @Input()
  @HostBinding('style.width')
  width;

  @Input() accept;

  @Input() processing: boolean;

  @Input() allowDelete = false;

  @Output() fileSelected = new EventEmitter();

  @Output() fileDeleted = new EventEmitter();

  @ViewChild("fileUpload")
  fileUpload: ElementRef;

  @Input()
  emptyImage = true;


  @Input() componentShape: 'square';


  CARD_EMPTY_IMG = CARD_EMPTY_IMG;
  EMPTY_IMG_SQUARE = EMPTY_IMG_SQUARE;

  constructor(private elementRef: ElementRef) {

  }

  ngOnInit() {

  }



  onMouseEnter() {
    this.editMode = true;
  }

  onMouseLeave() {
    this.editMode = false;
  }

  stateClasses() {
    if (this.editMode) {
      return 'edit-mode';
    }
  }

  containerStyles() {
    return {
      height: this.height,
      width: this.width
    };
  }

  editableImageStyles() {

    const styles = {
      height: this.height,
      width: this.width,
    };

    if (this.src) {
      styles['background-image'] = `url(${this.src})`;
    }

    return styles;
  }

  onFileSelected($event) {
    this.fileSelected.next($event);
  }


  open() {
    this.fileUpload.nativeElement.click();
  }

  onDelete() {
    this.fileDeleted.emit();
  }

  /*
  *
  * Enables the re-upload of the same file, which the user might want to do without noticing.
  *
  * The default behaviour is to ignore the upload of the same file, which would be surprising to the user.
  *
  * */

  onInputClicked(fileUpload: HTMLInputElement) {
    fileUpload.value = null;
  }

}
